import { apiInstance } from "@/shared/api/base"
import axios from "axios"
import { CommunicationStatsReadError, CommunicationStatsResponse } from "./types"

interface ApiErrorPayload {
    error_id?: unknown
    message?: unknown
}

export const getCommunicationStats = async (): Promise<CommunicationStatsResponse> => {
    const response = await apiInstance.handler.get<CommunicationStatsResponse>(
        "/communities/communication-stats",
        { authFailureMode: "local" },
    )

    return response.data
}

export const toCommunicationStatsReadError = (error: unknown): CommunicationStatsReadError => {
    if (!axios.isAxiosError<ApiErrorPayload>(error)) {
        return {
            kind: "transport",
            status: null,
            errorId: null,
            message: error instanceof Error ? error.message : "Не удалось загрузить статистику",
        }
    }

    const status = error.response?.status ?? null
    const errorId = typeof error.response?.data?.error_id === "string"
        ? error.response.data.error_id
        : null
    const responseMessage = error.response?.data?.message

    return {
        kind: status === 401 || errorId === "unauthorized" || errorId === "expired_access_token"
            ? "auth"
            : status === null
                ? "transport"
                : "http",
        status,
        errorId,
        message: typeof responseMessage === "string" && responseMessage.length > 0
            ? responseMessage
            : error.message || "Не удалось загрузить статистику",
    }
}
